import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageTransition } from '@core/components/ui';
import { NotFound } from '@core/pages';
import type { getRouteConfig } from '@core/utils/routes';

interface LayoutMainContentProps {
  routeConfig: ReturnType<typeof getRouteConfig>;
}

const LayoutMainContent: React.FC<LayoutMainContentProps> = ({
  routeConfig,
}) => (
  <PageTransition>
    <Routes>
      {routeConfig.map(({ path, component: Component }) => (
        <Route key={path} path={path} element={<Component />} />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </PageTransition>
);

export default LayoutMainContent;
